import React from 'react'
import { Navigate, Route } from 'react-router-dom'
import DashboardAdmin from './pages/DashboardSetting/Main'
import Dashboard from './pages/Dashboard/Dashboard'
import DataSourceForm from './pages/DataSource/DataSourceForm'
import DataSource from './pages/DataSource/Main'
import LocationForm from './pages/Location/LocationForm'
import LocationUpload from './pages/Location/LocationUpload'
import Location from './pages/Location/Main'
import MappingKey from './pages/MappingKey/Main'
import Profile from './pages/Profile/Profile'
import CriteriaDetail from './pages/Segment/Criteria/CriteriaDetail'
import CriteriaForm from './pages/Segment/Criteria/CriteriaForm'
import Segment from './pages/Segment/Main'
import SegmentDetail from './pages/Segment/Segment/SegmentDetail'
import SegmentForm from './pages/Segment/Segment/SegmentForm'
import SegmentPreview from './pages/Segment/Segment/SegmentPreview'
import Targeting from './pages/Targeting/Main'
import TargetForm from './pages/Targeting/TargetForm'
import TargetPreview from './pages/Targeting/TargetPreview'
import Taxonomy from './pages/Taxonomy/Main'
import DashboardSetting from './pages/DashboardSetting/DashboardSetting'
import Consumer360List from './pages/Consumer360/ConsumerList'
import { DashboardCategory } from './constants/DashboardConf'
import Group from './pages/Group/Main'
import BrandManagement from './pages/Group/BrandManagement'
import ConsumerDetail from './pages/Consumer360/ConsumerDetail'
import ApiKey from './pages/ApiKey/Main'
import Indicator from './pages/Indicator/Main'
import CrossDataSourceSetting from './pages/CrossDataSourceSetting/Main'
import Invoice from './pages/Invoice/Main'
import InvoiceForm from './pages/Invoice/forms/InvoiceForms'
import InvoiceDashboard from './pages/Invoice/dashboard/InvoiceDashboard'

export default [
  <Route key='profile' exact path="/profile" element={<Profile />}/>,
  <Route key='brandManagement' exact path="/brandManagement" element={<BrandManagement />}/>,

  <Route key='dashboard' exact path="/" element={<Navigate to="/dashboard" replace />}/>,
  <Route key='dashboard' exact path="/dashboard" element={<Dashboard />}/>,

  <Route key="location" exact path="/location">
    <Route index element={<Location />}/>
    <Route exact path="new" element={<LocationForm goBackPath="/location" addMode />}/>
    <Route exact path="edit" element={<LocationForm goBackPath="/location" editMode />}/>
    <Route exact path="upload" element={<LocationUpload goBackPath="/location" />}/>
  </Route>,

  <Route key="segment" exact path="/segment">
    <Route index element={<Segment />}/>
    <Route exact path="new" element={<SegmentForm goBackPath="/segment" addMode />}/>
    <Route exact path="edit" element={<SegmentForm goBackPath="/segment" editMode />}/>
    <Route exact path="preview" element={<SegmentPreview goBackPath="/segment" />}/>
    <Route exact path="criteria">
      <Route index element={<Navigate to="/segment" state={{ type: 'criteria' }} replace />}/>
      <Route exact path="new" element={<CriteriaForm goBackPath="/segment/criteria" addMode />}/>
      <Route exact path="edit" element={<CriteriaForm goBackPath="/segment/criteria" editMode />}/>
    </Route>
  </Route>,

  <Route key='targeting' exact path="/targeting">
    <Route index element={<Targeting />}/>
    <Route exact path="new" element={<TargetForm goBackPath="/targeting" addMode />}/>
    <Route exact path="preview" element={<TargetPreview goBackPath="/targeting" />}/>
  </Route>,

  <Route key='consumer360' exact path="/consumer360">
    <Route index element={<Consumer360List />}/>
    <Route exact path="detail" element={<ConsumerDetail goBackPath="/consumer360" />}/>
  </Route>,

  <Route key='groupManagement' exact path="/management/group" element={<Group />} />,

  <Route key='mappingKey' exact path="/management/mappingKey" element={<MappingKey />} />,

  <Route key='segmentManagement' exact path="/management/segment">
    <Route index element={<Segment viewOnly />}/>
    <Route exact path="detail" element={<SegmentDetail goBackPath="/management/segment" editMode viewOnly />}/>
    <Route exact path="preview" element={<SegmentPreview goBackPath="/management/segment" viewOnly />}/>
    <Route exact path="criteria">
      <Route index element={<Navigate to="/management/segment" state={{ type: 'criteria' }} viewOnly replace />}/>
      <Route exact path="detail" element={<CriteriaDetail goBackPath="/management/segment/criteria" />}/>
    </Route>
  </Route>,

  <Route key='targetingManagement' exact path="/management/targeting">
    <Route index element={<Targeting viewOnly />}/>
    <Route exact path="preview" element={<TargetPreview goBackPath="/management/targeting" />}/>
  </Route>,

  <Route key='dashboardSetting' exact path="/management/dashboardSetting">
    <Route index element={<DashboardAdmin />}/>
    <Route exact path="consumer360Setting" element={<DashboardSetting type={DashboardCategory.CONSUMER} goBackPath="/management/dashboardSetting" adminMode />}/>
    <Route exact path="segmentSetting" element={<DashboardSetting type={DashboardCategory.SEGMENT} goBackPath="/management/dashboardSetting" adminMode />}/>
    <Route exact path="groupDashboardSetting" element={<DashboardSetting type={DashboardCategory.GROUP} goBackPath="/management/dashboardSetting" adminMode />}/>
    <Route exact path="brandDashboardSetting" element={<DashboardSetting type={DashboardCategory.BRAND} goBackPath="/management/dashboardSetting" adminMode />}/>
  </Route>,

  <Route key='taxonomy' exact path="/management/taxonomy" element={<Taxonomy />} />,

  <Route key='dataSource' exact path="/management/dataSource">
    <Route index element={<DataSource />}/>
    <Route exact path="new" element={<DataSourceForm goBackPath="/management/dataSource" addMode />}/>
    <Route exact path="edit" element={<DataSourceForm goBackPath="/management/dataSource" editMode />}/>
  </Route>,

  <Route key='apiKey' exact path="/management/apiKey" element={<ApiKey />} />,

  <Route key='indicatorSetting' exact path="/management/indicatorSetting" element={<Indicator />} />,
  <Route key='crossDataSourceSetting' exact path="/management/crossDataSourceSetting" element={<CrossDataSourceSetting />} />,

  <Route key="consumerInsights" exact path="/consumerInsights">
    <Route index element={<Invoice />}/>
    <Route exact path="new" element={<InvoiceForm goBackPath="/consumerInsights" addMode />}/>
    <Route exact path="viewSetting" element={<InvoiceForm goBackPath="/consumerInsights" editMode viewOnly />}/>
    <Route exact path="preview" element={<InvoiceDashboard goBackPath="/consumerInsights" />}/>
    <Route exact path="audience">
      <Route index element={<Invoice goBackPath="/consumerInsights" audienceMode />}/>
      <Route exact path="new" element={<InvoiceForm goBackPath="/consumerInsights/audience" addMode audienceMode />}/>
      <Route exact path="edit" element={<InvoiceForm goBackPath="/consumerInsights/audience" editMode audienceMode />}/>
    </Route>
  </Route>
]
